import { emailOTPClient, magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { isNativeShell, NATIVE_API_ORIGIN } from './api-origin';

// When running in the Capacitor shell the SPA is served from
// https://localhost, so a relative `/api/auth` baseURL would point at
// nothing. Use the prod API origin instead; CapacitorHttp + the fetch
// patch handle the cross-origin cookie + CORS plumbing.
const baseURL = isNativeShell()
  ? `${NATIVE_API_ORIGIN}/api/auth`
  : `${window.location.origin}/api/auth`;

/**
 * Better-Auth client.
 *
 * Two sign-in flows live side by side:
 *   - magicLink: web's primary path — one-tap email link
 *   - emailOTP:  mobile's primary path — 6-digit code typed into the
 *                Capacitor shell, avoiding the URL handoff hell of
 *                "tap link in Gmail → opens Chrome → cookie in the wrong jar"
 *
 * Both are surfaced via the Landing page, which branches on
 * Capacitor.isNativePlatform() (see lib/capacitor.ts → isNative()).
 *
 * The base URL is the web origin + /api/auth, so requests go through
 * the Vite dev proxy and the session cookie stays on the web origin
 * (see vite.config.ts). In production the API and the SPA share an
 * origin so this is a no-op.
 */
export const authClient = createAuthClient({
  baseURL,
  plugins: [magicLinkClient(), emailOTPClient()],
});

export const { useSession, signIn, signOut } = authClient;
export const { emailOtp } = authClient;
